import { p as proxyCustomElement, H, h, a as Host } from './index.js';

// Icons should always be lazy loaded, meaning a function that returns a Promise with the SVG markup.
const GRAPH_ICONS_LIGHT = {
    '404': async () => await import('./p-aC79BZ8b.js'),
    'access-denied': async () => await import('./p-Bju_n1AQ.js'),
    'account-suspended': async () => await import('./p-B5cgeBm1.js'),
    'app-construction': async () => await import('./p-DxMN5tFs.js'),
    'browser-not-supported': async () => await import('./p-BABwOyZ_.js'),
    'email-sent': async () => await import('./p-CSKmwBpK.js'),
    'empty-live-channels-list': async () => await import('./p-p6_GSNiK.js'),
    'empty-ott-list-page': async () => await import('./p-DOD3x4sZ.js'),
    'empty-series': async () => await import('./p-msQfwiiA.js'),
    'empty-playlist': async () => await import('./p-D9nOCJ4C.js'),
    empty: async () => await import('./p-DhtIOLqL.js'),
    'link-expired': async () => await import('./p-l8ThRW2s.js'),
    'no-data-retrieved': async () => await import('./p-XGr5PoQF.js'),
    'no-search-result': async () => await import('./p-CXXqPJ35.js'),
    'unsubscribe-error': async () => await import('./p-kCP1Qwas.js'),
    'unsubscribe-success': async () => await import('./p-CXDl6125.js'),
};
// Icons should always be lazy loaded, meaning a function that returns a Promise with the SVG markup.
const GRAPH_ICONS_DARK = {
    '404': async () => await import('./p-DomJgPSc.js'),
    'access-denied': async () => await import('./p-BmQk09Dw.js'),
    'account-suspended': async () => await import('./p-CDxdDH_7.js'),
    'app-construction': async () => await import('./p-DoFew9iw.js'),
    'browser-not-supported': async () => await import('./p-B4k3qeoq.js'),
    'email-sent': async () => await import('./p-Oj_kETo_.js'),
    'empty-live-channels-list': async () => await import('./p-Cqjxfagl.js'),
    'empty-ott-list-page': async () => await import('./p-CV1emu99.js'),
    'empty-series': async () => await import('./p-D7KNTqpQ.js'),
    'empty-playlist': async () => await import('./p-BzaOqeNc.js'),
    empty: async () => await import('./p-D2nzloAM.js'),
    'link-expired': async () => await import('./p-MB1UW5Q0.js'),
    'no-data-retrieved': async () => await import('./p-CCBZvseo.js'),
    'no-search-result': async () => await import('./p-DWb5JcT5.js'),
    'unsubscribe-error': async () => await import('./p-DcDJqxmi.js'),
    'unsubscribe-success': async () => await import('./p-B3BE5XC_.js'),
};

const GRAPH_ICON_NAMES = [
    '404',
    'access-denied',
    'account-suspended',
    'app-construction',
    'browser-not-supported',
    'email-sent',
    'empty-live-channels-list',
    'empty-ott-list-page',
    'empty-series',
    'empty-playlist',
    'empty',
    'link-expired',
    'no-data-retrieved',
    'no-search-result',
    'unsubscribe-error',
    'unsubscribe-success',
];

const graphIconCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:fit-content}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}div{display:none}div[data-theme=light]{display:var(--wui-graph-icon--display-light)}div[data-theme=dark]{display:var(--wui-graph-icon--display-dark)}";

const checkGraphIconValid = (name) => {
    return name === 'NULL' || typeof name === 'undefined' || !GRAPH_ICON_NAMES.includes(name);
};
const getGraphIconSvgLight = async (name) => {
    if (checkGraphIconValid(name))
        return '';
    const fn = GRAPH_ICONS_LIGHT[name];
    const ret = await fn();
    return ret.default;
};
const getGraphIconSvgDark = async (name) => {
    if (checkGraphIconValid(name))
        return '';
    const fn = GRAPH_ICONS_DARK[name];
    const ret = await fn();
    return ret.default;
};
const WuiGraphIcon = /*@__PURE__*/ proxyCustomElement(class WuiGraphIcon extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * GraphIcon name
         */
        this.name = 'NULL';
        this.svgLight = '';
        this.svgDark = '';
    }
    // We lazy load all icon SVGs by watching when the `name` and `theme` property change.
    // We then request the icon asynchronously, and once its loaded, we replace
    // the internal state with the new SVG markup.
    async watchName() {
        this.svgLight = await getGraphIconSvgLight(this.name);
        this.svgDark = await getGraphIconSvgDark(this.name);
    }
    componentWillLoad() {
        // Load the initial icon SVG by triggering the watch function.
        this.watchName();
    }
    render() {
        return (h(Host, { key: '174ad7f3289886ce4d890624a4152caec1c62ea4' }, h("div", { key: '7e0898f64b9eb6fae72e930576cc1980a4dc9bc5', innerHTML: this.svgLight, "data-theme": "light" }), h("div", { key: '48e02c004282e1d7e9662f7280969beaa37312a6', innerHTML: this.svgDark, "data-theme": "dark" })));
    }
    static get watchers() { return {
        "name": ["watchName"]
    }; }
    static get style() { return graphIconCss; }
}, [257, "wui-graph-icon", {
        "name": [1],
        "svgLight": [32],
        "svgDark": [32]
    }, undefined, {
        "name": ["watchName"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-graph-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-graph-icon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiGraphIcon);
            }
            break;
    } });
}
defineCustomElement();

export { WuiGraphIcon as W, defineCustomElement as d };
